import { supabase } from '../supabase/client.js';

const ASSIGNMENTS_TABLE = 'vim_pay_project_assignments';

function tableUnavailable(error) {
  const code = String(error?.code || '').toUpperCase();
  const message = String(error?.message || '');
  return code === '42P01'
    || code === 'PGRST205'
    || /relation .*vim_pay_project_assignments.* does not exist/i.test(message)
    || /could not find the table .*vim_pay_project_assignments/i.test(message);
}

export async function listMyProjectAssignments() {
  if (!supabase) return { configured: false, assignments: [] };

  const { data, error } = await supabase
    .from(ASSIGNMENTS_TABLE)
    .select(`
      id,
      project_id,
      worker_id,
      role_name,
      department,
      rate_amount,
      rate_unit,
      commission_rate_percent,
      authorized_units,
      currency,
      status,
      work_start,
      work_end,
      fringe_profile_key,
      rate_validation_status,
      created_at,
      updated_at,
      project:vim_pay_projects(
        id,
        name,
        code,
        production_type,
        status,
        base_labor_budget,
        start_date,
        end_date
      )
    `)
    .order('created_at', { ascending: false });

  if (error) {
    if (tableUnavailable(error)) return { configured: false, assignments: [] };
    throw error;
  }

  return { configured: true, assignments: Array.isArray(data) ? data : [] };
}

export function baseCommitment(assignment) {
  if (assignment?.rate_unit === 'commission') return 0;
  const rate = Number(assignment?.rate_amount || 0);
  const units = Number(assignment?.authorized_units || 0);
  if (!Number.isFinite(rate) || !Number.isFinite(units)) return 0;
  return Math.round((rate * units + Number.EPSILON) * 100) / 100;
}
